/*
 * Type verification and coercion.
 *
 * TODO: Support more types.
 */
export default class Coerce {
    static getName(arg) {
        // Get the name of the prototype. (ex Object, Array, String...)
        return Object.prototype.toString.call(arg).slice(8, -1);
    }
    getName(...args) {
        return this.constructor.getName.apply(this, args);
    }

    static Object(arg, fallback = {}) {
        // If it's not an object, return an empty one.
        return arg === Object(arg) ? arg : fallback;
    }
    Object(...args) {
        return this.constructor.Object.apply(this, args);
    }

    static Array(arg) {
        // If it's an array, return the array.
        return Array.isArray(arg) ? arg : [arg];
    }
    Array(...args) {
        return this.constructor.Array.apply(this, args);
    }
}
